// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `canvas[data-v-6e45eb9e] {
  width: 100%;
  height: 400px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/monetization/OverviewSankeyGraph.vue","webpack://./OverviewSankeyGraph.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\ncanvas {\n  width: 100%;\n  height: 400px;\n}\n","canvas {\n  width: 100%;\n  height: 400px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
